import type { Infer } from 'superstruct';
import {
	boolean,
	number,
	object,
	optional,
	partial,
	string,
	union,
} from 'superstruct';

export const ViewFacebookPageDto = object({
	id: string(),
	name: string(),
	website: optional(string()),
	link: string(),
	location: optional(
		union([
			string(),
			partial(
				object({
					city: string(),
					country: string(),
					latitude: number(),
					longitude: number(),
					state: string(),
					street: string(),
					zip: string(),
				})
			),
		])
	),
	adAccountId: string(),
	adAccountName: string(),
	avbId: string(),
});

export type ViewFacebookPageDto = Infer<typeof ViewFacebookPageDto>;

export const FacebookAdAccountPageOptionDto = object({
	id: string(),
	name: string(),
	website: string(),
	link: string(),
	databaseLinked: optional(boolean()),
	availableToAdAccount: optional(boolean()),
});

export type FacebookAdAccountPageOptionDto = Infer<
	typeof FacebookAdAccountPageOptionDto
>;
